// AI-ASSISTED: generated with claude-code (Opus 4.8) on 2026-09-14, reviewed by Yoann Hertienne
//
// Flag-aware sidebar entry for /releases (spec 004-release-feed, FR-023):
// renders the nav item only when the backend reports the
// `backstage-releases-view` flag is on (GET /api/releases/enabled), so a
// disabled feature hides the tab entirely instead of linking to a 404. Reads
// the state once on mount (reload to reflect a live flag flip). Mirrors
// modules/maintenance/MaintenanceSidebarItem.tsx.
import useAsync from 'react-use/lib/useAsync';
import { SidebarItem } from '@backstage/core-components';
import { discoveryApiRef, fetchApiRef, useApi } from '@backstage/core-plugin-api';
import NewReleasesIcon from '@mui/icons-material/NewReleases';
import { ReleasesApiClient } from './api/ReleasesApiClient';

export const ReleasesSidebarItem = () => {
  const discoveryApi = useApi(discoveryApiRef);
  const fetchApi = useApi(fetchApiRef);

  const { value: enabled } = useAsync(async () => {
    const client = new ReleasesApiClient({ discoveryApi, fetchApi });
    return client.enabled();
  }, [discoveryApi, fetchApi]);

  if (!enabled) return null;
  return <SidebarItem icon={NewReleasesIcon} to="/releases" text="Releases" />;
};
